/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — calendar-month helpers for the booking date picker
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      moment-timezone
 *   siblings:  booking-people.js, booking-steps.js, booking-filters.js, booking-request.js, booking-validation.js
 *   tests:     none
 *   gotchas:   clearCalendarAvailability/markCalendarAvailability drive
 *              ember-power-calendar's day buttons via a direct `available` DOM
 *              attribute (styled off by the stylesheet) — there is no
 *              component API for it; reschedule-modal.js does the same thing
 *              inline instead of importing these.
 *
 * Calendar-month helpers carved out of controllers/index.js: pure moment-based
 * month range plus two DOM helpers for power-calendar day availability.
 */
import moment from 'moment-timezone';

export function clearCalendarAvailability() {
  document.querySelectorAll('button.ember-power-calendar-day').forEach((el) => {
    el.setAttribute('available', false);
  });
}

export function markCalendarAvailability(dates) {
  dates.forEach((date) => {
    document
      .querySelectorAll(`button.ember-power-calendar-day[data-date='${date}']`)
      .forEach((el) => {
        el.setAttribute('available', true);
      });
  });
}

// Start/end of the month containing `date`, expressed in the booking timezone.
export function monthRange(date, timeZone) {
  const momentDate = moment(date);

  return {
    from_date: momentDate.startOf('month').tz(timeZone).format('YYYY-MM-DDTHH:mmZ'),
    to_date: momentDate.endOf('month').tz(timeZone).format('YYYY-MM-DDTHH:mmZ'),
  };
}
